<template>
  <v-card>
    <v-card-title class="text-subtitle-1">
      {{ $t('firmware.diagnostic.list-title') }}
      <v-spacer />
      <v-btn small text @click="load" :loading="loading">
        <v-icon small left>mdi-refresh</v-icon>{{ $t('refresh') }}
      </v-btn>
    </v-card-title>
    <v-card-subtitle>{{ $t('firmware.diagnostic.list-explained') }}</v-card-subtitle>
    <v-card-text>
      <firmware-diagnostics-table :items="items" :loading="loading" show-charging-point @downloaded="load" />
      <div v-if="moreAvailable" class="text-center mt-2">
        <v-btn small text :loading="loadingMore" @click="loadMore">{{ $t('firmware.updates.load-more') }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import FirmwareRepository from "@repository/FirmwareRepository";
import FirmwareDiagnosticsTable from "./FirmwareDiagnosticsTable.vue";

/** Toutes les demandes de diagnostic du parc ; elles se lancent depuis la fiche d'une borne. */
export default {
  components: {FirmwareDiagnosticsTable},

  data() {
    return {items: [], loading: false, moreAvailable: false, loadingMore: false}
  },

  mounted() {
    this.load()
  },

  methods: {
    // Les demandes plus anciennes, par pages de 100.
    loadMore() {
      this.loadingMore = true
      FirmwareRepository.diagnostics(null, this.items.length).then(items => {
        this.items = [...this.items, ...items]
        this.moreAvailable = items.length === 100
      }).catch(err => {
        this.notifyError(err)
      }).finally(() => {
        this.loadingMore = false
      })
    },

    load() {
      this.loading = true
      FirmwareRepository.diagnostics().then(items => {
        this.items = items
        this.moreAvailable = items.length === 100
      }).catch(err => {
        this.notifyError(err)
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>
